module.exports = __webpack_public_path__ + "img/alert.19213889.png";